module.exports = __webpack_public_path__ + "img/microphone.714d9242.svg";